// extracted by mini-css-extract-plugin
export default {"container":"P__2CZ"};